'use client';

import { User } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { HeaderAuthContainer } from '@/components/header-auth-container';
import { paths } from '@/lib/config/paths.config';

const links = [
  { href: paths.features, label: 'Funcionalidades' },
  { href: paths.solutions, label: 'Soluções' },
  { href: paths.resources, label: 'Recursos' },
  { href: paths.pricing, label: 'Planos' },
  { href: paths.support, label: 'Contato' },
];

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container flex h-20 items-center justify-between">
        <div className="flex items-center gap-8">
          <Link
            href={paths.root}
            className="flex items-center space-x-2 transition-opacity hover:opacity-80"
          >
            <Image
              src="/images/logo-black.svg"
              alt="Vibe"
              width={95}
              height={35}
              className="h-9 w-auto"
            />
          </Link>
          <nav className="hidden gap-8 md:flex">
            {links.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="group relative inline-flex h-8 cursor-pointer items-center justify-center font-medium text-gray-600 transition-colors hover:text-gray-900"
              >
                {link.label}
                <span className="-bottom-1 absolute left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full" />
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-6">
          <Link
            href={paths.auth.signIn}
            className="flex items-center gap-2 px-6 py-2.5 font-medium text-gray-700 transition-all hover:bg-gray-100 hover:text-gray-900"
          >
            <User size={18} className="text-gray-500" />
            Entrar na Conta
          </Link>
          <HeaderAuthContainer />
        </div>
      </div>
    </header>
  );
}
